<template>
<div>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-heading mb-4">Umsatzlisten Export </h4>
            <b-form-group
                content-cols="8"
                label-cols="4"
                label="Market Account"
                label-for="input-horizontal"
            >
              <b-form-select v-model="salesListInput.marketAccountId" :options="marketAccountOptions"></b-form-select>
            </b-form-group>
            <b-form-group
                content-cols="8"
                label-cols="4"
                label="Monat"
                label-for="input-horizontal"
            >
              <b-form-select v-model="salesListInput.month" :options="monthOptions"></b-form-select>
            </b-form-group>

            <b-form-group
                content-cols="8"
                label-cols="4"
                label="Jahr"
                label-for="input-horizontal"
            >
              <b-form-select v-model="salesListInput.year" :options="yearsOptions"></b-form-select>
            </b-form-group>
            <b-btn class="float-right" variant="primary" @click="exportSalesList">Exportieren <b-spinner small label="Spinning" v-if="requestInProgress && selectedExportType === 'salesList'"></b-spinner></b-btn>
          </div>
        </div>
      </div>
    </div>
  </div>

	<div class="container my-3 my-md-5">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
          <div class="card-body">
						<h4 class="card-heading mb-4">Lieferschein Rechnungs Export </h4>
            <b-row>
              <div class="col-6">
						<b-form-group
              content-cols="8"
              label-cols="4"            
              label="Market Account"
              label-for="input-horizontal"            
            >
              <b-form-select v-model="deliveryNoteInvoiceInput.marketId" :options="filteredMarketAccountOptions"></b-form-select>
						</b-form-group>

						<b-form-group
              content-cols="8"
              label-cols="4"            
              label="Jahr"
              label-for="input-horizontal"            
            >
								<b-form-select v-model="deliveryNoteInvoiceInput.year" :options="yearsOptions"></b-form-select>
						</b-form-group>
            
              <b-form-group
                content-cols="8"
                label-cols="4"
                label="Monat"
                label-for="input-horizontal"         
              >
                <b-form-select v-model="deliveryNoteInvoiceInput.month" :options="monthOptions"></b-form-select>
              </b-form-group>

                <b-form-group
                    class=""
                    content-cols="8"
                    label-cols="4"
                    label="Rechnungsnummer EUR"
                    label-for="input-horizontal"
                >
                  <b-form-input v-model="deliveryNoteInvoiceInput.invoiceIdEuro"></b-form-input>
                </b-form-group>

                <b-form-group
                  class=""
                  content-cols="8"
                  label-cols="4"            
                  label="Netto gesamt"
                  label-for="input-horizontal"            
                >
                  <b-form-input v-model="deliveryNoteInvoiceInput.totalNetAmount"></b-form-input>
                </b-form-group>


              <div v-for="n in invoiceCount" class="mt-4" :key="n">
                <b-form-group
                    class=""
                    content-cols="8"
                    label-cols="4"
                    label="Rechnungsnummer"
                    label-for="input-horizontal"
                >
                  <b-form-input v-model="deliveryNoteInvoiceInput.invoices[n-1].id"></b-form-input>
                </b-form-group>

                <b-form-group
                  class=""
                  content-cols="8"
                  label-cols="4"            
                  label="Rechnungsbetrag"
                  label-for="input-horizontal"            
                >
                  <b-form-input v-model="deliveryNoteInvoiceInput.invoices[n-1].invoiceAmount"></b-form-input>
                </b-form-group>

                <b-form-group
                  content-cols="8"
                  label-cols="4"            
                  label="Währung"
                  label-for="input-horizontal"            
                >
                  <b-form-select v-model="deliveryNoteInvoiceInput.invoices[n-1].currency" :options="currencyOptions"></b-form-select>
                </b-form-group>
              </div>
              <b-btn variant="secondary" @click="addInvoice">+</b-btn>           
              <b-btn v-if="invoiceCount > 1" variant="secondary" @click="removeInvoice"> - </b-btn>
              </div>
              <div class="col-6">
                <div v-if="invoices.length > 0" class="">
                  <div v-for="(invoice, index) in invoices" :key="index" class="">
                    <span class="mt-3">Rechnung: {{invoice.invoiceAmount ? invoice.invoiceAmount : "Restbetrag"}} / {{invoice.currency ? invoice.currency : "EUR"}}</span>
                    <div class="d-flex">
                    <b-form-group class=" w-25 mt-auto" label="Brutto Umsatz" label-for="grossSum">
                      <b-form-input disabled :value="formattedGrossSum(invoice.reducedGrossSum)" id="grossSum" ></b-form-input>
                    </b-form-group>
                    <b-form-group class="w-25 mt-auto" label="Ware voller Steuersatz" label-for="tax19">
                      <b-form-input disabled :value="formattedSum19Tax(invoice.sum19tax)" id="tax19"></b-form-input>
                    </b-form-group>
                    <b-form-group class="w-25 mt-auto" label="Ware ermäßigter Steuersatz" label-for="tax7">
                      <b-form-input disabled :value="formattedSum7Tax(invoice.sum7tax)" id="tax7"></b-form-input>
                    </b-form-group>                                                   
                      <b-btn class="mb-3 mt-auto" @click="downloadPdf(invoice)"><i class="bi bi-download"></i></b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <b-btn class="float-right" variant="primary" @click="exportFullfillment">Exportieren <b-spinner small label="Spinning" v-if="requestInProgress && selectedExportType === 'fulfillment'"></b-spinner></b-btn>
					</div>
				</div>
			</div>
		</div>
	</div>
	<modal-error-component v-model="modalError"></modal-error-component>
</div>
</template>

<script>
export default{
  props: [
    'marketAccounts','filteredMarketAccounts', 'markets'
  ],
  data(){
    return {
      marketAccountOptions: [],
      filteredMarketAccountOptions: [],
      markeOptions : [],
      startYear : 2021,
      currentYear: Number(moment().format('YYYY')),
      yearsOptions: [],      
      monthOptions: [],
      currencyOptions: [],
      salesListInput: {
        year: moment().format('YYYY'),
        month: '',
        marketAccountId: '',
      },
      deliveryNoteInvoiceInput: {
        year: moment().format('YYYY'),
        month: '',
        marketId: '',
        marketName: '',
        totalNetAmount: '',
        invoiceIdEuro: '',
        invoices: [],
      },      
      invoiceCount: 1,
      invoices: [],
      requestInProgress: false,
      selectedExportType: 'salesList',
      modalError: {
        show: false,
        message: 'unpopulated',
        error: 'unpopulated',
        title: 'unpopulated'
      },
    }
  },
  computed: {
    marketName () {
      const market = this.filteredMarketAccountOptions.find(market => market.value === this.deliveryNoteInvoiceInput.marketId)
      return market.text
    }
  },
  methods:{
    exportFullfillment(){
    	this.selectedExportType = 'fulfillment';
    	this.requestInProgress = true;

      this.deliveryNoteInvoiceInput.marketName = this.marketName;
      axios.post('saleslist/fullfillment', this.deliveryNoteInvoiceInput)
      .then(res => {
				this.requestInProgress = false;
        this.invoices = res.data;

        this.invoices.forEach(invoice => {
          const b64String = invoice.base64String;
          const binaryString = atob(b64String);
          const view = new Uint8Array(Array.from(binaryString).map(char => char.charCodeAt(0)));
          invoice.blobUrl = window.URL.createObjectURL(new Blob([view], { type: 'application/pdf' }));
        });
      })
      .catch(error => {
				this.requestInProgress = false;
        this.modalError = {
          show: true,
          message: 'Ein Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.response?.data ??  error.message ?? error,
          title: 'Export fehlgeschlagen'
        };
      console.log(error)
      })
    },
    addInvoice(){
      this.invoiceCount ++;
      this.deliveryNoteInvoiceInput.invoices.push(
        {
          invoiceAmount: '',
          currency: '',
        })
    },
    removeInvoice(){
      this.invoiceCount --;
      this.deliveryNoteInvoiceInput.invoices.pop();
    },
    cutDecimals(number){
      return number.toFixed(2);
    },
    downloadPdf(invoice){
      const link = document.createElement('a');
      link.href = invoice.blobUrl;
      link.setAttribute('download', this.formatFileName(invoice)+'.pdf');
      document.body.appendChild(link);
      link.click();
    },
    formatFileName(invoice){
      const cur =   invoice.currency ? invoice.currency : 'EUR';
      const date = moment(invoice.startDate).format("MM.YYYY");
      return 'Lieferschein_' + this.marketName + '_' + cur + "_"+ date
    },
    exportSalesList(){
			this.selectedExportType = 'salesList';
			this.requestInProgress = true;
      axios.post('/saleslist', this.salesListInput)
      .then(res => {
				this.requestInProgress = false;
        const newWindow = window.open('', '_blank');
        newWindow.document.write(res.data); // Write the HTML response to the new tab
        newWindow.document.close();
      })
      .catch(error => {
				this.requestInProgress = false;
        this.modalError = {
          show: true,
          message: 'Ein Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.response?.data ??  error.message ?? error,
          title: 'Export fehlgeschlagen'
        };
      console.log(error)
      })
    },
    formattedGrossSum(value){
      return value.toFixed(2);
    },
    formattedSum19Tax(value){
      return value.toFixed(2);
    },
    formattedSum7Tax(value){
      return value.toFixed(2);
    },
  },
  created(){
    this.monthOptions = 
    [
      { value: 1, text: 'Januar' },
      { value: 2, text: 'Februar' },
      { value: 3, text: 'März' },
      { value: 4, text: 'April' },
      { value: 5, text: 'Mai' },
      { value: 6, text: 'Juni' },
      { value: 7, text: 'Juli' },
      { value: 8, text: 'August' },
      { value: 9, text: 'September' },
      { value: 10, text: 'Oktober' },
      { value: 11, text: 'November' },
      { value: 12, text: 'Dezember' }
    ];

    this.yearsOptions = Array.from({length: this.currentYear - this.startYear + 1}, (_, index) => this.startYear + index);
    const formattedMarketAccounts = Object.keys(this.marketAccounts).map(key => ({ id: key, name: this.marketAccounts[key] }));
    this.marketAccountOptions = formattedMarketAccounts.map(ma => {
      return {
        value : ma.id,
        text: ma.name
      }
    });
    this.filteredMarketAccountOptions = this.markets.map(ma => {
      return {
        value : ma.id,
        text: ma.name
      }
    });
    this.currencyOptions = _.uniq(this.filteredMarketAccounts.map((x) => { return x.country.currencyIso }) ).filter((x) => { return x !== 'EUR' }).map((x) => {
      return {
        value: x,
        text: x
      };
    });
    this.deliveryNoteInvoiceInput.invoices.push({invoiceAmount: '', currency: '', id: ''})
  },
}
</script>